import "dotenv/config"
import React from "react"
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import ReactDOM from "react-dom"
import App from "./App"
import "./i18next"
import "./icons"
import * as serviceWorker from "./serviceWorker"
import "./instrument"

ReactDOM.render(<App />, document.getElementById("root"))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

if (module.hot) module.hot.accept()
